<section>
  <app-dashboard-card-with-title
    class="users-comments"
    [headerImage]="'./../../../../../../assets/images/comments.svg'"
    [headerTitle]="'WHITE_LABEL_DASHBOARD.COMMENT_CARDS.COMMENTS_HEADER' | translate"
  >
    <div class="comments">
      <ng-container *ngFor="let item of comments?.latestReviews">
        <app-comment-card [comment]="item"></app-comment-card>
      </ng-container>
    </div>
  </app-dashboard-card-with-title>

  <app-dashboard-card-with-title
    class="users-rate"
    [headerImage]="'../../../../../../assets/images/Star.svg'"
    [headerTitle]="'WHITE_LABEL_DASHBOARD.COMMENT_CARDS.CLIENTS_RATING_HEADER' | translate"
  >
    <app-clients-rating [rate]="comments?.overAllRate"></app-clients-rating>
  </app-dashboard-card-with-title>
</section>
